<!--
说明：当用户点击博主的名字后，进入；分为两种情况，
    1. 如果是从 popup popupingEntity 页面进入的，则是新弹出一个 tab 进行显示
    2. 如果是从 popupingEntity 页面进入的，则直接走路由的方式

注意事项：
    1. 千万不要把 div 标签改成了 span，之前因为 div 会默认占用一行导致 tooltip 定位不准确的问题，将其改成了 span，但是，这样导致 ellipsis
       的样式设置又成了问题，因为 span 默认是展示所有内容，不接受 overflow hidden，导致必须准确的设置 span 的 width 才能有 ellipsis 的
       效果。因此，为了调和上述的两个问题，在 UserFollows 需要使用到 ellipsis 的组件中默认使用 div，在需要 tooltip 精准定位的 ProfileSection
       组件中，通过动态注入 display: inline-block 将其修改为 span 特性解决 tooltip 定位问题。

-->
<template>
    <div v-if="name === null" :style="[styleObject, {cursor: pointer}]">....</div>
    <div v-else
         :class="{'profile-name': isNavigable, 'profile-name-hover': isClicking}"
         :style="[styleObject, {cursor: pointer}]"
         title="进入我的 Space"
         @click="navigate">{{name}}</div>
</template>

<script>
    import {ShowEntityMode, isMobileAgent, isPhoneAgent, isHybridAgent} from "../../utils";
    import {BACKEND_BASE_URL} from '../../../config/env';

    export default {
        name: "ProfileName",
        props: {
            name: {
                type: String,
                default: null
            },  // the profile name
            code: String,  // the profile code
            styleObject: Object,
        },
        computed: {
            pointer: function(){
                return this.isNavigable ? 'pointer' : 'default';
            },
            isNavigable: function(){
                return this.$store.getters.getIsProfileNameNavigble();
            }
        },
        data(){
            return {
                isClicking: false // only works for the mobile agent.
            }
        },
        methods: {
            /**
             * 1. 如果是 popup popupingEntity，则跳转到一个新的窗口
             * 2. 如果是 Single Page，则打开一个新的路由即可。
             */
            navigate(){
                // @since v2.3.0 为了防止免费用户蹭流量，只有我的 Chrome 浏览器的 Samsung Galaxy S20 Ultra 才会显示；
                if(this.$store.getters.getIsProfileNameNavigble() && window.navigator.userAgent.indexOf('Linux; Android 10; SM-G981B') > 0){
                    var mode = this.$store.getters.getShowEntityMode();
                    if(isMobileAgent()){  // 只有 mobile 环境下才会触发 clicking 然后渲染 name 的style
                        this.isClicking = true;
                    }
                    if(isHybridAgent()){
                        mode = ShowEntityMode.SinglePageMode; // 强制设置为 single page mode;
                    }
                    console.log(`profile name, navigate to ${this.code} with mode ${mode}`);
                    if(mode == ShowEntityMode.SinglePageMode){
                        var timeout = isMobileAgent() ? 100: 1 // 想了想还是给个 1，如果设置为 0 不知道在其它浏览器上是不是会有 BUG
                        setTimeout(()=>{
                            if(isHybridAgent()){
                                // 控制 profile 的展示方式
                                this.$store.commit('setShowEntityMode', ShowEntityMode.SinglePageMode);
                                // FIX for HCF327 - 手机端在用户中心喜欢/收藏的弹出 entity 页面中，点击 profile name 路由到 profile 页面，弹出窗口不关闭
                                this.$EventBus.$emit('closepopups');
                            }
                            this.$router.push({path: `/p/${this.code}`});
                        }, timeout)  // 给 100 毫秒的延迟是配合移动端 isClicking 后的 profilename 点击后的样式变化。
                    }
                    else if(mode == ShowEntityMode.PopupPageMode){ // 新开窗口显示 Profile（PC 端目前的做法）
                        window.open(`/p/${this.code}`);  // 这里不用写 BASE URL 会自动的根据当前的 BASEURL 跳转。
                    }
                }
                this.$emit('navigated');
            }
        }

    }
</script>

<style scoped>
    /* 切记，hover 事件只在 PC 端添加，否则 IOS H5 会出现 double click link 才能生效的问题 */
    @media (min-width: 736px) {
        .profile-name:hover {
            color: #CB0101; /* Constants red color*/
            text-decoration: underline;
        }
    }
    /* 在移动端为了避免 IOS H5 hover 的问题，定义了该属性，当点击用户名的时候，做样式变换 */
    .profile-name-hover {
        color: #CB0101; /* Constants red color*/
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/profile/Name.vue